export const officeVocab = [
  {
    word: "procurement",
    meaning: "조달, 구매",
    example:
      "The procurement department handles all purchases for the company.",
    translation: "조달부서가 회사의 모든 구매를 담당합니다.",
  },
  {
    word: "logistics",
    meaning: "물류",
    example: "Our logistics team ensures efficient delivery of all products.",
    translation: "우리 물류팀은 모든 제품의 효율적인 배송을 보장합니다.",
  },
  {
    word: "inventory management",
    meaning: "재고 관리",
    example: "Effective inventory management is crucial for reducing costs.",
    translation: "효과적인 재고 관리는 비용 절감을 위해 매우 중요합니다.",
  },
  {
    word: "dispatch",
    meaning: "발송하다, 배차하다",
    example: "We need to dispatch these goods by tomorrow morning.",
    translation: "이 물품들을 내일 아침까지 발송해야 합니다.",
  },
  {
    word: "customs clearance",
    meaning: "통관",
    example: "The shipment is delayed due to customs clearance procedures.",
    translation: "화물이 통관 절차로 인해 지연되고 있습니다.",
  },
  {
    word: "documentation",
    meaning: "서류 작업, 문서화",
    example: "All shipping documentation must be completed before export.",
    translation: "수출 전에 모든 선적 서류가 완료되어야 합니다.",
  },
  {
    word: "warehouse facilities",
    meaning: "창고 시설",
    example:
      "We're expanding our warehouse facilities to meet increasing demand.",
    translation: "증가하는 수요를 충족하기 위해 창고 시설을 확장하고 있습니다.",
  },
  {
    word: "supply chain",
    meaning: "공급망",
    example: "The company is working to optimize its supply chain efficiency.",
    translation: "회사는 공급망 효율성을 최적화하기 위해 노력하고 있습니다.",
  },
  {
    word: "quality assurance",
    meaning: "품질 보증",
    example:
      "Our quality assurance team inspects all products before shipment.",
    translation: "우리 품질 보증팀은 출하 전에 모든 제품을 검사합니다.",
  },
  {
    word: "distribution network",
    meaning: "유통망",
    example: "We're expanding our distribution network across Asia.",
    translation: "우리는 아시아 전역으로 유통망을 확장하고 있습니다.",
  },
  {
    word: "import declaration",
    meaning: "수입 신고서",
    example: "They need a revised import declaration form from our supplier.",
    translation: "공급업체로부터 수정된 수입신고서가 필요합니다.",
  },
  {
    word: "supplier",
    meaning: "공급업체",
    example: "We need to find a new supplier for office supplies.",
    translation: "사무용품에 대한 새로운 공급업체를 찾아야 합니다.",
  },
  {
    word: "maintenance",
    meaning: "유지보수",
    example: "Regular maintenance is essential for machine operation.",
    translation: "정기적인 유지보수는 기계 작동에 필수적입니다.",
  },
  {
    word: "assembly line",
    meaning: "조립 라인",
    example: "The new model will be produced on the assembly line next month.",
    translation: "새 모델은 다음 달에 조립 라인에서 생산될 예정입니다.",
  },
  {
    word: "defective",
    meaning: "결함이 있는",
    example: "These defective products must be returned to the manufacturer.",
    translation: "이 결함이 있는 제품들은 제조사로 반품되어야 합니다.",
  },
  {
    word: "stockroom",
    meaning: "창고, 저장실",
    example: "Please check the stockroom for additional supplies.",
    translation: "추가 물품이 있는지 저장실을 확인해 주세요.",
  },
  {
    word: "equipment",
    meaning: "장비, 설비",
    example: "The factory needs new equipment to increase production.",
    translation: "공장은 생산량을 늘리기 위해 새로운 장비가 필요합니다.",
  },
  {
    word: "urgent documents",
    meaning: "긴급 서류",
    example: "I need to print some urgent documents for the meeting.",
    translation: "회의를 위해 긴급 서류를 출력해야 합니다.",
  },
  {
    word: "out of order",
    meaning: "고장난, 작동하지 않는",
    example:
      "The printer is out of order. It keeps displaying an error message.",
    translation: "프린터가 고장났어요. 계속 에러 메시지가 뜨네요.",
  },
  {
    word: "error message",
    meaning: "오류 메시지",
    example: "Every time I attempt to use it, it shows an error message.",
    translation: "사용할 때마다 오류 메시지가 표시됩니다.",
  },
  {
    word: "technician",
    meaning: "기술자",
    example: "Let me schedule a technician to take a look at it.",
    translation: "기술자를 불러 확인해보도록 하겠습니다.",
  },
  {
    word: "malfunction",
    meaning: "오작동, 고장",
    example: "The printer appears to be malfunctioning.",
    translation: "프린터가 오작동하는 것 같습니다.",
  },
  {
    word: "maintenance team",
    meaning: "유지보수팀",
    example: "According to our maintenance team's standard procedures.",
    translation: "저희 유지보수팀의 일반적인 절차에 따르면.",
  },
  {
    word: "operational",
    meaning: "작동하는, 운영 중인",
    example:
      "I'll be sure to reach out to you the moment it's operational again.",
    translation: "다시 작동하는 즉시 연락드리도록 하겠습니다.",
  },
  {
    word: "conflict",
    meaning: "충돌, 갈등",
    example:
      "It has been rescheduled due to a conflict with another department.",
    translation: "다른 부서와 일정이 겹쳐서 일정이 변경되었습니다.",
  },
  {
    word: "report due",
    meaning: "보고서 제출 기한",
    example: "I have a report due then.",
    translation: "그때 제출해야 할 보고서가 있어요.",
  },
  {
    word: "verify",
    meaning: "확인하다",
    example: "I wanted to verify something about tomorrow's meeting.",
    translation: "내일 회의에 대해 확인하고 싶은 게 있어서요.",
  },
  {
    word: "pull up",
    meaning: "불러오다, 확인하다",
    example: "Let me pull up the conference room schedule real quick.",
    translation: "회의실 일정을 빠르게 확인해보겠습니다.",
  },
  {
    word: "spam folder",
    meaning: "스팸 폴더",
    example: "Have you checked your spam folder?",
    translation: "스팸 폴더는 확인해보셨나요?",
  },
  {
    word: "filtered",
    meaning: "필터링된",
    example: "It seems it was automatically filtered into that folder.",
    translation: "자동으로 그 폴더에 필터링되어 있었나 봐요.",
  },
  {
    word: "import declaration form",
    meaning: "수입신고서",
    example: "They need a revised import declaration form from our supplier.",
    translation: "공급업체로부터 수정된 수입신고서가 필요합니다.",
  },
  {
    word: "customs",
    meaning: "세관",
    example: "Our shipment to Germany is stuck at customs.",
    translation: "독일로 가는 우리 화물이 세관에 막혔어요.",
  },
  {
    word: "health insurance plan",
    meaning: "건강 보험 플랜",
    example: "I have a quick question about our health insurance plan.",
    translation: "우리 건강 보험 플랜에 대해 간단히 질문이 있습니다.",
  },
  {
    word: "dental coverage",
    meaning: "치과 보험",
    example: "Does it include dental coverage?",
    translation: "치과 보험도 포함되나요?",
  },
  {
    word: "vision care",
    meaning: "시력 관리",
    example: "That's covered as well, but only for an annual eye exam.",
    translation: "그것도 보장되지만, 연간 시력 검사에만 해당됩니다.",
  },
  {
    word: "salary adjustment",
    meaning: "급여 조정",
    example:
      "I'd like to discuss my salary adjustment and the benefits package.",
    translation: "제 급여 조정과 복리후생 패키지에 대해 논의하고 싶습니다.",
  },
  {
    word: "flexible working hours",
    meaning: "유연 근무제",
    example:
      "I'd like to know if there are options for flexible working hours.",
    translation: "유연근무제 옵션이 있는지 알고 싶습니다.",
  },
  {
    word: "performance-based bonuses",
    meaning: "성과급",
    example: "I was wondering if the company offers performance-based bonuses.",
    translation: "회사에서 성과급을 제공하는지 궁금합니다.",
  },
  {
    word: "conference facilities",
    meaning: "회의 시설",
    example: "Our new office has state-of-the-art conference facilities.",
    translation: "우리 새 사무실에는 최첨단 회의 시설이 있습니다.",
  },
  {
    word: "reschedule",
    meaning: "일정을 변경하다",
    example: "We need to reschedule the meeting due to a scheduling conflict.",
    translation: "일정이 겹쳐서 회의 일정을 변경해야 합니다.",
  },
  {
    word: "deadline extension",
    meaning: "기한 연장",
    example: "I would like to request a deadline extension for the project.",
    translation: "프로젝트 기한 연장을 요청하고 싶습니다.",
  },
  {
    word: "production capacity",
    meaning: "생산 능력",
    example: "We need to increase our production capacity to meet demand.",
    translation: "수요를 충족하기 위해 생산 능력을 높여야 합니다.",
  },
  {
    word: "quality control standards",
    meaning: "품질 관리 기준",
    example: "All products must meet our quality control standards.",
    translation: "모든 제품은 품질 관리 기준을 충족해야 합니다.",
  },
  {
    word: "safety regulations",
    meaning: "안전 규정",
    example: "The factory must comply with all safety regulations.",
    translation: "공장은 모든 안전 규정을 준수해야 합니다.",
  },
  {
    word: "stock levels",
    meaning: "재고 수준",
    example: "We need to maintain adequate stock levels at all times.",
    translation: "항상 적절한 재고 수준을 유지해야 합니다.",
  },
  {
    word: "inventory tracking",
    meaning: "재고 추적",
    example: "Our new system helps with accurate inventory tracking.",
    translation: "새로운 시스템이 정확한 재고 추적을 도와줍니다.",
  },
  {
    word: "storage capacity",
    meaning: "보관 용량",
    example: "We're reaching maximum storage capacity in the warehouse.",
    translation: "창고가 최대 보관 용량에 도달하고 있습니다.",
  },
  {
    word: "shipping manifest",
    meaning: "선적 명세서",
    example: "Please check the shipping manifest for any discrepancies.",
    translation: "불일치 사항이 있는지 선적 명세서를 확인해주세요.",
  },
  {
    word: "customs declaration",
    meaning: "세관 신고",
    example: "All international shipments require a customs declaration.",
    translation: "모든 국제 배송은 세관 신고가 필요합니다.",
  },
  {
    word: "delivery route optimization",
    meaning: "배송 경로 최적화",
    example: "We're working on delivery route optimization to reduce costs.",
    translation: "비용 절감을 위해 배송 경로 최적화 작업을 하고 있습니다.",
  },
  {
    word: "freight forwarding",
    meaning: "화물 운송",
    example: "Our freight forwarding service ensures timely delivery.",
    translation: "우리의 화물 운송 서비스는 정시 배송을 보장합니다.",
  },
  {
    word: "loading dock",
    meaning: "화물 적재장",
    example: "Please deliver all materials to the loading dock.",
    translation: "모든 자재를 화물 적재장으로 배송해 주세요.",
  },
  {
    word: "cargo insurance",
    meaning: "화물 보험",
    example: "All shipments are covered by cargo insurance.",
    translation: "모든 배송품은 화물 보험이 적용됩니다.",
  },
  {
    word: "agenda items",
    meaning: "회의 안건",
    example: "Please submit any agenda items by tomorrow morning.",
    translation: "회의 안건이 있으시면 내일 아침까지 제출해 주세요.",
  },
  {
    word: "minutes of meeting",
    meaning: "회의록",
    example: "The minutes of meeting will be circulated by email.",
    translation: "회의록은 이메일로 공유될 예정입니다.",
  },
  {
    word: "quarterly review",
    meaning: "분기 검토",
    example: "The quarterly review meeting is scheduled for next week.",
    translation: "분기 검토 회의가 다음 주로 예정되어 있습니다.",
  },
  {
    word: "purchase order",
    meaning: "구매 주문서",
    example: "We need to process this purchase order immediately.",
    translation: "이 구매 주문서를 즉시 처리해야 합니다.",
  },
  {
    word: "invoice processing",
    meaning: "송장 처리",
    example: "There's a delay in invoice processing this month.",
    translation: "이번 달 송장 처리가 지연되고 있습니다.",
  },
  {
    word: "work order",
    meaning: "작업 지시서",
    example: "Please submit a work order for equipment repair.",
    translation: "장비 수리를 위한 작업 지시서를 제출해 주세요.",
  },
  {
    word: "quality inspection",
    meaning: "품질 검사",
    example: "All products must pass the quality inspection before shipping.",
    translation: "모든 제품은 출하 전에 품질 검사를 통과해야 합니다.",
  },
  {
    word: "production schedule",
    meaning: "생산 일정",
    example: "We need to adjust the production schedule to meet the deadline.",
    translation: "납기를 맞추기 위해 생산 일정을 조정해야 합니다.",
  },
  {
    word: "batch processing",
    meaning: "일괄 처리",
    example: "The new system allows for efficient batch processing.",
    translation: "새로운 시스템으로 효율적인 일괄 처리가 가능합니다.",
  },
  {
    word: "bill of lading",
    meaning: "선하증권",
    example: "Please forward the bill of lading to our shipping department.",
    translation: "선하증권을 우리 배송부서로 전달해 주세요.",
  },
  {
    word: "delivery confirmation",
    meaning: "배송 확인서",
    example: "We require a delivery confirmation for all shipments.",
    translation: "모든 배송에 대해 배송 확인서가 필요합니다.",
  },
  {
    word: "tracking number",
    meaning: "운송장 번호",
    example: "The tracking number will be sent once the order ships.",
    translation: "주문이 발송되면 운송장 번호를 보내드리겠습니다.",
  },
  {
    word: "progress report",
    meaning: "진행 보고서",
    example: "The progress report is due by the end of this week.",
    translation: "진행 보고서는 이번 주 말까지 제출해야 합니다.",
  },
  {
    word: "compliance documentation",
    meaning: "규정 준수 문서",
    example: "All compliance documentation must be up to date.",
    translation: "모든 규정 준수 문서는 최신 상태여야 합니다.",
  },
  {
    word: "audit findings",
    meaning: "감사 결과",
    example: "The audit findings will be presented next month.",
    translation: "감사 결과는 다음 달에 발표될 예정입니다.",
  },
];
